/***
*
*   PERMISSION GATE
*   Conditionally renders children based on user permissions
*
*   PROPS
*   menu: string - the menu key (e.g. 'feedback')
*   action: string - 'view', 'edit', 'delete'
*   fallback: optional component to render when not permitted
*
**********/

import { usePermissions } from 'components/hooks/usePermissions';

export function PermissionGate({ menu, action = 'view', fallback = null, children }) {
  const { can } = usePermissions();

  if (!can(menu, action)) {
    return fallback;
  }

  return children;
}